import React from 'react';
import { Grid } from '@mui/material'; 
import CardMenu from './CardMenu';

export default function MenuSection({ arr, name }) {
  if (!arr || arr.length === 0) return null;
  return (
    <Grid item>
      <CardMenu arr={arr} name={name} />
    </Grid>
  );
}